<!-- 本月工单处理进度 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <div style="display: flex;height: 100%;">
        <!-- <div id="chart" style="height: 100%;width: 65%;"></div> -->
        <Echart :options="option" style="height: 100%;width: 65%"></Echart>
        <div class="progress">
          <div v-for="item in progressList" :key="item.type">
            <div class="title">
              <div>{{item.typeName}}</div>
              <div><i>{{item.typeTotal}}</i></div>
            </div>
            <a-progress :strokeColor="color[item.type]" :percent="item.rate" :strokeWidth="15" :show-info="false" class="finish" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    props: {
      titleImage: {
          type: String,
          default: ''
      },
    },
    data() {
      return {
        title: this.$t('本月工单处理进度'),
        option: {},
        url:{
            queryProgressOfTheMonthByEmergency:"/jeecg-engineering/ticket/index/largeScreen/queryProgressOfTheMonthByEmergency"
        },
        OnLineStatistical:[],
        intervalId: null,
        angle: 0,
        progressList: [],
        color: ['#69D389','#E02020','#FFC328','#019AF3']
      }
    },
    mounted() {},
    methods: {
      init() {
        this.resetData();
        this.getData();
      },
      resetData() {
          this.option = this.$options.data.call(this).option
          if(this.intervalId !== null){
              clearInterval(this.intervalId)
              this.intervalId = null;
          }
          this.angle = this.$options.data.call(this).angle
      },
      getData(){
        postAction(this.url.queryProgressOfTheMonthByEmergency,{}).then(res=>{
          if(res.success){
            var data = res.result;
            data.progressOfTheMonthByEmergencyInnerVOS.map(p=>{
              this.progressList.push({
                typeName: p.typeName,
                typeTotal: p.typeTotal,
                type: p.type,
                rate: ((p.typeTotal/data.total)*100).toFixed(2)
              })
            })
            this.setOption(data)
            // setTimeout(()=> {
            //     this.intervalId = setInterval(()=>{
            //         this.angle = this.angle + 5
            //         this.setOption(data)
            //     },100)
            // },1000)
          }
        })
      },
      setOption(formal) {
        let that = this;
        let angle = this.angle
        let data = [];
        formal.progressOfTheMonthByEmergencyInnerVOS.map(p=>{
          data.push({
            name: p.typeName,
            value: p.typeTotal
          })
        })
        let total = formal.total;
        let seriesData = []
        for (let i = 0; i < data.length; i++) {
          seriesData.push({
            name: data[i].name,
            value: data[i].value,
            itemStyle: {
              normal: {
                borderWidth: 5,
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: that.color[i]
                    },
                    {
                      offset: 1,
                      color: that.color[i]
                    }
                  ]
                ),
                borderColor: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: that.color[i]
                    },
                    {
                      offset: 1,
                      color: that.color[i]
                    }
                  ]
                ),

              }
            }
          })
        }
        this.option = {
          color: ['#E02020', '#1DCC8C'],
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          title: {
            text: `{total|${total}}{unit|${this.$t('件')}}`,
            textStyle: {
              color: '#52C4DF',
              rich: {
                total: {
                  color: '#52C4DF',
                  fontWeight: 500,
                  fontSize: 24,
                  fontFamily: 'ds-digital-bold'

                },
                unit: {
                  color: '#2A6BAC',
                  fontSize: 12,
                }
              }
            },
            left: 'center',
            top: 'center',
            itemGap: 0,
            subtext: this.$t('已处理'),
            subtextStyle: {
              color: '#fff',
              verticalAlign: 'middle',
              lineHeight: 12
            }
          },
          series: [{
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                    startAngle: (0 + angle) * Math.PI / 180,
                    endAngle: (90 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    opacity: 0.5,
                    fill: "transparent",
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                    startAngle: (120 + angle) * Math.PI / 180,
                    endAngle: (210 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    opacity: 0.5,
                    fill: "transparent",
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                    startAngle: (240 + angle) * Math.PI / 180,
                    endAngle: (330 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    fill: "transparent",
                    opacity: 0.5,
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: '',
              type: 'pie',
              radius: ['50%', '55%'],
              center: ['50%', '50%'],
              animationDelay: 100,
              animationDuration: 2000,
              label: {
                show: false,
                position: 'outer',
                width: 0,
                height: 0,
                lineHeight: 0,
                padding: [2, -2, 2, -2],
                borderRadius: 2,
                distanceToLabelLine: 0,
                // formatter: function(params) {
                //   if (total == 0) {
                //     let percent = 100
                //   }
                //   let index = params.dataIndex
                //   let percent = ((params.value / total) * 100).toFixed(0);
                //   return [
                //     `{topnumber${index}|${params.value}}{top${index}|个}{topnumber${index}|${percent}}{top${index}|%}\n{bottom${index}|${params.name}}`,
                //     `{hr${index}|}`
                //   ].join('\n')
                // },
                align: 'center',
                // rich: this.setRichText(color)
              },
              labelLine: {
                normal: {
                  smooth: 0.2,
                  length: 15,
                  length2: 45,
                }
              },
              data: seriesData
            }
          ]
        };
      },
      setRichText(colorList) {
        let richList = {}
        for (let i = 0; i < colorList.length; i++) {
          richList[`top${i}`] = {
            color: colorList[i].start,
            verticalAlign: 'bottom',
            padding: [5, 0, 0, 0],
            align: 'center'
          }
          richList[`topnumber${i}`] = {
            color: colorList[i].start,
            fontFamily: 'ds-digital-bold',
            verticalAlign: 'bottom',
            padding: [5, 0, 0, 0],
            fontSize: 20,
            align: 'center'
          }
          richList[`bottom${i}`] = {
            color: colorList[i].start,
            verticalAlign: 'top',
            padding: [0, 0, 5, 0],
            align: 'center'
          }
          richList[`hr${i}`] = {
            backgroundColor: colorList[i].start,
            borderRadius: 3,
            width: 3,
            height: 3,
            align: 'center',
            padding: [3, 3, 0, -12]
          }
        }
        return richList
      },
    },
    beforeDestroy() {
        this.angle = 0;
        if(this.intervalId !== null){
            clearInterval(this.intervalId)
            this.intervalId = null;
        }
    }
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}

  .ant-radio-button-wrapper {
    color: #fff;
    background: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #1890FF;
  }

  .progress {
    width: 35%;
    font-size: 12px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    /deep/.ant-progress-line {
      margin-bottom: 25px;
    }

    /deep/.finish .ant-progress-inner {
      background-color: #08306F;
    }

    /deep/.notfinish .ant-progress-inner {
      background-color: #20515B;
    }

    /deep/.timeout .ant-progress-inner {
      background-color: #5B5B34;
    }
  }
</style>